import React from 'react';
import {FlexRow, Button} from '@forecast-it/design-system';
import Logo, {LOGO_SIZE} from '../../shared/components/logo/Logo';
import {FLEX_ALIGN_ITEMS} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import {LogoWrapper} from '../primary/PrimaryNavigationMain';

type ActionBarProps = {
	onClickSave: () => void;
	onClickCancel: () => void;
};

const ActionBar = ({onClickSave, onClickCancel}: ActionBarProps): React.JSX.Element => {
	const {formatMessage} = useIntl();

	return (
		<FlexRow>
			<LogoWrapper>
				<Logo size={LOGO_SIZE.SMALL} />
			</LogoWrapper>
			<FlexRow flex="1 1 auto" alignSelf={FLEX_ALIGN_ITEMS.END} justifyContent={FLEX_ALIGN_ITEMS.END}>
				<Button onPress={onClickSave}>{formatMessage({id: 'common.save_changes'})}</Button>
				<Button onPress={onClickCancel} emphasis="medium">
					{formatMessage({id: 'common.cancel'})}
				</Button>
			</FlexRow>
		</FlexRow>
	);
};

export default ActionBar;
